import { InjectionToken } from '@angular/core';
import { createMocks } from '@backbase/foundation-ang/data-http';
export const PRODUCT_SUMMARY_DATA_HTTP_ANG_CONFIG = new InjectionToken(
  'product-summary-data-http-ang Data Service :: HTTP Config',
);
const examples = [
  {
    urlPattern: '/client-api/{version}/productsummary',
    method: 'GET',
    responses: [
      {
        status: 200,
        body: {
          "currentAccounts": {
              "name": "Current Accounts",
              "aggregatedBalance": {},
              "products": []
          },
          "savingsAccounts": {
              "additions": {
                  "totalBalance": "5039.31",
                  "display": "yes",
                  "iban": "1200083899",
                  "productKindName": "Cuentas de ahorros",
                  "productTypeName": "Cuenta de ahorro Baneskin",
                  "currencyCode": "DOP"
              },
              "name": "Savings Accounts",
              "aggregatedBalance": {},
              "products": [
                  {
                      "additions": {
                          "totalBalance": "79.92",
                          "display": "yes",
                          "iban": "1200046573",
                          "productKindName": "Cuentas de ahorros",
                          "productTypeName": "Cuenta ahorro nómina Banesco",
                          "currencyCode": "DOP"
                      },
                      "id": "1865091c-c448-47e3-aaa6-23e1d7a02dd6",
                      "name": "saving account",
                      "displayName": "Cuentas de ahorros",
                      "crossCurrencyAllowed": true,
                      "productKindName": "Savings Account",
                      "productTypeName": "Ahorro nómina",
                      "bankAlias": "Cuentas de ahorros",
                      "visible": true,
                      "accountOpeningDate": "2016-05-03T00:00:00Z",
                      "bookedBalance": "79.92",
                      "availableBalance": "79.92",
                      "IBAN": "1200046573",
                      "BBAN": "1200046573",
                      "currency": "DOP"
                  },
                  {
                      "additions": {
                          "totalBalance": "3952.43",
                          "display": "yes",
                          "iban": "1200055232",
                          "productKindName": "Cuentas de ahorros",
                          "productTypeName": "null",
                          "currencyCode": "DOP"
                      },
                      "id": "4b6c0a02-993b-4152-b57a-2e5e761d0aee",
                      "name": "saving account",
                      "displayName": "Cuentas de ahorros",
                      "crossCurrencyAllowed": true,
                      "productKindName": "Savings Account",
                      "productTypeName": "Ahorro",
                      "bankAlias": "Cuentas de ahorros",
                      "visible": true,
                      "accountOpeningDate": "2018-05-11T00:00:00Z",
                      "bookedBalance": "3952.43",
                      "availableBalance": "3952.43",
                      "IBAN": "1200055232",
                      "BBAN": "1200055232",
                      "currency": "DOP"
                  },
                  {
                      "additions": {
                          "totalBalance": "5039.31",
                          "display": "yes",
                          "iban": "1200083899",
                          "productKindName": "Cuentas de ahorros",
                          "productTypeName": "Cuenta de ahorro Baneskin",
                          "currencyCode": "DOP"
                      },
                      "id": "ccbeced1-4485-4c87-9d07-b2fd053cde4a",
                      "name": "saving account",
                      "displayName": "Cuentas de ahorros",
                      "crossCurrencyAllowed": true,
                      "productKindName": "Savings Account",
                      "productTypeName": "Baneskin",
                      "bankAlias": "Cuentas de ahorros",
                      "visible": true,
                      "accountOpeningDate": "2022-05-12T04:00:00Z",
                      "bookedBalance": "5039.31",
                      "availableBalance": "5039.31",
                      "IBAN": "1200083899",
                      "BBAN": "1200083899",
                      "currency": "DOP",
                      "startDate": "2024-02-01T11:24:06.892Z",
                      "accountHolderNames": "JULIET HANANIAN JULIET HANANIAN"
                  }
              ]
          },
          "termDeposits": {
              "name": "Term Deposits",
              "aggregatedBalance": {},
              "products": []
          },
          "loans": {
              "name": "Loans",
              "aggregatedBalance": {},
              "products": []
          },
          "creditCards": {
              "additions": {
                  "totalBalance": "24407.93",
                  "display": "yes",
                  "foreignCurrency": "US",
                  "productKindName": "Visa SuperCashBack",
                  "foreignTotalBalance": "-1",
                  "localCurrency": "RD",
                  "localCurrencyCode": "DOP",
                  "foreignAvailableBalance": "-1",
                  "availableBalance": "592.07",
                  "localLimitBalance": "25000.00",
                  "foreignLimitBalance": "-1",
                  "localPercentageUsed": "98",
                  "localAvailableBalance": "592.07",
                  "foreignPercentageUsed": "-1",
                  "iban": "400588******2110",
                  "localUsedBalance": "23815.86",
                  "productTypeName": "Visa SuperCashBack",
                  "foreignCurrencyCode": "USD",
                  "creditCardAccountNumber": "400588******2110",
                  "cardTypeCode": "T",
                  "mainCardNumber": "4005880257132110",
                  "localTotalBalance": "24407.93",
                  "foreignUsedBalance": "-1"
              },
              "name": "Credit Cards",
              "aggregatedBalance": {},
              "products": [
                  {
                      "additions": {
                          "display": "no"
                      },
                      "id": "93edbd95-c682-4e7f-b900-354433ae8e99",
                      "name": "credit card",
                      "displayName": "Tarjetas de credito",
                      "crossCurrencyAllowed": true,
                      "productKindName": "Credit Card",
                      "productTypeName": "Visa Gold",
                      "bankAlias": "Tarjetas de credito",
                      "visible": true,
                      "bookedBalance": "0.00000",
                      "availableBalance": "635.64000",
                      "currency": "DOP"
                  },
                  {
                      "additions": {
                          "display": "no"
                      },
                      "id": "ace78339-0161-45c5-a33f-bd68d9c1518a",
                      "name": "credit card",
                      "displayName": "Tarjetas de credito",
                      "crossCurrencyAllowed": true,
                      "productKindName": "Credit Card",
                      "productTypeName": "Multicrédito",
                      "bankAlias": "Tarjetas de credito",
                      "visible": true,
                      "bookedBalance": "0.00000",
                      "availableBalance": "2077.32000",
                      "currency": "DOP"
                  },
                  {
                      "additions": {
                          "totalBalance": "24407.93",
                          "display": "yes",
                          "foreignCurrency": "US",
                          "productKindName": "Visa SuperCashBack",
                          "foreignTotalBalance": "-1",
                          "localCurrency": "RD",
                          "localCurrencyCode": "DOP",
                          "foreignAvailableBalance": "-1",
                          "availableBalance": "592.07",
                          "localLimitBalance": "25000.00",
                          "foreignLimitBalance": "-1",
                          "localPercentageUsed": "98",
                          "localAvailableBalance": "592.07",
                          "foreignPercentageUsed": "-1",
                          "iban": "400588******2110",
                          "localUsedBalance": "23815.86",
                          "productTypeName": "Visa SuperCashBack",
                          "foreignCurrencyCode": "USD",
                          "creditCardAccountNumber": "400588******2110",
                          "cardTypeCode": "T",
                          "mainCardNumber": "4005880257132110",
                          "localTotalBalance": "24407.93",
                          "foreignUsedBalance": "-1"
                      },
                      "id": "c7e13c7a-5833-46b5-af68-0e9558f68a14",
                      "name": "credit card",
                      "displayName": "Visa SuperCashBack",
                      "crossCurrencyAllowed": true,
                      "productKindName": "Credit Card",
                      "productTypeName": "Visa SupercashBack",
                      "bankAlias": "Visa SuperCashBack",
                      "visible": true,
                      "bookedBalance": "0.00000",
                      "availableBalance": "592.07",
                      "currency": "DOP",
                      "accountHolderNames": "ABIMAEL  GIL VASQUEZ"
                  }
              ]
          },
          "debitCards": {
              "name": "Debit Cards",
              "aggregatedBalance": {},
              "products": []
          },
          "investmentAccounts": {
              "name": "Investment Accounts",
              "aggregatedBalance": {},
              "products": []
          },
          "customProductKinds": []
      }
      },
    ],
  },
  {
    urlPattern: '/client-api/{version}/productsummary/configuration',
    method: 'GET',
    responses: [
      {
        status: 500,
        body: {
          message: 'Description of error',
        },
        type: 'TraitsInternalServerError',
      },
      {
        status: 403,
        body: {
          message: 'Access to requested resource denied.',
          errors: [
            {
              message: 'Resource access denied due to an insufficient user quota of {quota}.',
              key: 'common.api.quota',
              context: {
                quota: 'someQuota',
              },
            },
          ],
        },
        type: 'TraitsForbiddenError',
      },
      {
        status: 400,
        body: {
          message: 'Bad Request',
          errors: [
            {
              message: 'Value Exceeded. Must be between {min} and {max}.',
              key: 'common.api.shoesize',
              context: {
                max: '50',
                min: '1',
              },
            },
          ],
        },
        type: 'TraitsBadRequestError',
      },
      {
        status: 200,
        body: [
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4691',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Mr and Mrs J. Smith 2',
            bankAlias: 'Our joined account',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'CY3887370130MJFTJ3B8Y9W7IGRO',
            BBAN: '8873701303897',
            currency: 'AED',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Current Account',
            productTypeName: 'Current Account',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Paris',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Danthe Mohr',
            accountHolderNames: 'Danthe Mohr,Toso Malerot',
            accountHolderCountry: 'FR',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Our joined account',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Current Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Current Account',
                kindUri: 'current-account',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
          },
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4692',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Howlin Wolf',
            bankAlias: 'Royalties account',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 15000,
            availableBalance: 21500,
            creditLimit: 3442.12,
            IBAN: 'GB60OHSF29521903589133',
            BBAN: '029521903589133',
            currency: 'AED',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Current Account',
            productTypeName: 'Current Account',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Toso Malerot',
            accountHolderNames: 'Toso Malerot,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Royalties account',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Current Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Current Account',
                kindUri: 'current-account',
              },
            },
            state: {
              externalStateId: 'externalStateId2',
              state: 'InActive',
            },
          },
          {
            id: '3cdb2224-8926-4b4d-a99f-1c9dfbbb4600',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Company saving account',
            bankAlias: 'Langosh, Okuneva and Spencer',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 10550000,
            availableBalance: 1500,
            IBAN: 'IT09R0442267398V9QB48EV3THQ',
            BBAN: '904422673989483',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 36.16,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Savings Account',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Mile Panika',
            accountHolderNames: 'Mile Panika,Toso Malerot',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Langosh, Okuneva and Spencer',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Saving Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Saving Account',
                kindUri: 'Saving-account',
              },
            },
            state: {
              externalStateId: 'externalStateId2',
              state: 'Open',
            },
          },
          {
            id: '4cdb2224-8926-4b4d-a99f-1c9dfbbb4697',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: '3 Month Deposit',
            bankAlias: 'My Term Deposit',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 10550000,
            IBAN: 'NL81TRIO0212471066',
            BBAN: '096842613153393963',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 36.16,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Term Deposit',
            productTypeName: 'My Term Deposit',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Toso Malerot',
            accountHolderNames: 'Toso Malerot,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'My Term Deposit',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Saving Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Saving Account',
                kindUri: 'Saving-account',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
          },
          {
            id: '5cdb2224-8926-4b4d-a99f-1c9dfbbb4696',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'House Loan',
            bankAlias: 'Our home loan',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 150000,
            principalAmount: 200000,
            IBAN: 'LU29806Y5C5H8IC1INZL',
            BBAN: '98065581',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Loan',
            productTypeName: 'House Loan',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Terence McCullough',
            accountHolderNames: 'Terence McCullough,Toso Malerot',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Our home loan',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'House Loan',
              productKind: {
                id: 5,
                externalKindId: 'kind5',
                kindName: 'Loan',
                kindUri: 'loan',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
          },
          {
            id: '2d94d333-471d-4cd7-84d2-24e822d5ca68',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Jason Smith Credit Card',
            bankAlias: 'JS Credit Card',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1250,
            availableBalance: 750,
            creditLimit: 5000,
            IBAN: 'PL47959864897829628098071024',
            BBAN: '7959864897829628098071024',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: '1234',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Credit Card',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Jason Smith',
            accountHolderNames: 'Jason Smith,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'JS Credit Card',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Investment Account',
              productKind: {
                id: 7,
                externalKindId: 'kind7',
                kindName: 'Investment Account',
                kindUri: 'investment-account',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
            additions: {
              "foreignCurrency": "US",
              "foreignTotalBalance": "0.00",
              "localCurrency": "RD",
              "localCurrencyCode": "DOP",
              "foreignAvailableBalance": "2066.78",
              "localPercentageUsed": "0",
              "localAvailableBalance": "120000.00",
              "foreignPercentageUsed": "0",
              "foreignCurrencyCode": "USD",
              "creditCardAccountNumber": "4850730028704000",
              "cardTypeCode": "M",
              "localTotalBalance": "0.00"
            },
          },
          {
            id: '7cdb2224-8926-4b4d-a99f-1c9dfbbb4699',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Mr J. Smith',
            bankAlias: 'My debit card',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'RO46MHPMQM2ZAIS8MDOYXJXR',
            BBAN: '628',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Debit Card',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Alaine Kautzer III',
            accountHolderNames: 'Alaine Kautzer III,Toso Malerot',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'My debit card',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Investment Account',
              productKind: {
                id: 7,
                externalKindId: 'kind7',
                kindName: 'Investment Account',
                kindUri: 'investment-account',
              },
            },
          },
          {
            id: '8cdb2224-8926-4b4d-a99f-1c9dfbbb4695',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Mr J. Smith Execution only portfolio',
            bankAlias: 'Mr J. Investment Account',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'SI08965141761504424',
            BBAN: '8965141761504424',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 75789,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Investment Account',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'James Bond',
            accountHolderNames: 'James Bond,Toso Malerot,Jason Smith',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Mr J. Investment Account',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Investment Account',
              productKind: {
                id: 7,
                externalKindId: 'kind7',
                kindName: 'Investment Account',
                kindUri: 'investment-account',
              },
            },
          },
          {
            id: '6c1261e8-7b6b-4c14-9bb4-e976d834c730',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: '3 Month Deposit Investment',
            bankAlias: '3 Month Investment',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'SM04K79780125717VXPJ4QPEVV4',
            BBAN: '47978012571744',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 88500,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Loan',
            productTypeName: 'Car Loan',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Otto Zulauf',
            accountHolderNames: 'Otto Zulauf,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: '3 Month Investment',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Car Loan',
              productKind: {
                id: 5,
                externalKindId: 'kind5',
                kindName: 'loan',
                kindUri: 'loan',
              },
            },
          },
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4622',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Custom Product Kind Type 1',
            productKindName: 'My Custom Product Kind',
            productTypeName: 'My Custom Product Kind Type1',
            bankAlias: 'Custom Product Kind Type 1',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'EE044174502653307781',
            BBAN: '44174502653307781',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Colby Harvey',
            accountHolderNames: 'Colby Harvey,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Custom Product Kind Type 1',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Savings Account',
              productKind: {
                id: 2,
                externalKindId: 'kind2',
                kindName: 'Savings Account',
                kindUri: 'savings-account',
              },
            },
          },
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4611',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'House loan account',
            bankAlias: 'My Custom Product Kind Type 2',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'DE78342773203296369720',
            BBAN: '8342773203296369720',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'My Custom Product Kind',
            productTypeName: 'My Custom Product Kind Type2',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Tony Stark',
            accountHolderNames: 'Tony Stark,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'My Custom Product Kind Type 2',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'House Loan',
              productKind: {
                id: 5,
                externalKindId: 'kind5',
                kindName: 'Loan',
                kindUri: 'loan',
              },
            },
            parentId: '1cdb2224-8926-4b4d-a99f-1c11223344',
            externalParentId: 'bcf10f4d-4b2f-4413-9bab-31ff623243125',
          },
        ],
        type: 'ProductsummaryFlatStructureGET',
      },
    ],
  },
  {
    urlPattern: '/client-api/{version}/productsummary/context/arrangements',
    method: 'GET',
    responses: [
      {
        status: 500,
        body: {
          message: 'Description of error',
        },
        type: 'TraitsInternalServerError',
      },
      {
        status: 403,
        body: {
          message: 'Access to requested resource denied.',
          errors: [
            {
              message: 'Resource access denied due to an insufficient user quota of {quota}.',
              key: 'common.api.quota',
              context: {
                quota: 'someQuota',
              },
            },
          ],
        },
        type: 'TraitsForbiddenError',
      },
      {
        status: 400,
        body: {
          message: 'Bad Request',
          errors: [
            {
              message: 'Value Exceeded. Must be between {min} and {max}.',
              key: 'common.api.shoesize',
              context: {
                max: '50',
                min: '1',
              },
            },
          ],
        },
        type: 'TraitsBadRequestError',
      },
      {
        status: 200,
        body: [
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4691',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Mr and Mrs J. Smith 3',
            bankAlias: 'Our joined account',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'CY3887370130MJFTJ3B8Y9W7IGRO',
            BBAN: '8873701303897',
            currency: 'AED',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Current Account',
            productTypeName: 'Current Account',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Paris',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Danthe Mohr',
            accountHolderNames: 'Danthe Mohr,Toso Malerot',
            accountHolderCountry: 'FR',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Our joined account',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Current Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Current Account',
                kindUri: 'current-account',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
            "additions": {
              "accountInterestRateDOP": "-1",
              "accountInterestRateUSD": "-1",
              "minimumPmtDOP": "1434.43",
              "minimumPmtUSD": "-1",
              "accumulatedPaymentsDOP": "0.0000",
              "accumulatedPaymentsUSD": "-1",
              "expiredFees": "-1",
              "currentBalancePoints": "-1",
              "creditLimitDOP": "53946.06",
              "lastBalanceUSD": "-1",
              "creditLimitUSD": "-1",
              "mainCardNumber": "4850740095675009",
              "totalBalanceDOP": "32536.11",
              "totalBalanceUSD": "-1",
              "deferredBalanceDOP": "0.00",
              "deferredBalanceUSD": "-1",
              "lastPmtDate": "05-11-2020",
              "feeAmountDueUSD": "-1",
              "cardType": "Visa clasica",
              "lastBalanceDOP": "32536.11",
              "availableBalanceUSD": "-1",
              "minimumPmtSemaphoreDOP": "Red",
              "minimumPmtSemaphoreUSD": "-1",
              "availableBalanceDOP": "21678.84",
              "totalPaymentUSD": "-1",
              "totalPaymentDOP": "0.00",
              "mainCardName": "STARLIN FERNANDEZ GOMEZ",
              "cardTypeCode": "M",
              "lastPmtAmountUSD": "-1",
              "feeAmountDueDOP": "-1",
              "bankProductType": "94",
              "lastPmtAmountDOP": "1.00",
              "status": "success"
            }
          },
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4692',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Howlin Wolf',
            bankAlias: 'Royalties account',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 15000,
            availableBalance: 21500,
            creditLimit: 3442.12,
            IBAN: 'GB60OHSF29521903589133',
            BBAN: '029521903589133',
            currency: 'AED',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Current Account',
            productTypeName: 'Current Account',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Toso Malerot',
            accountHolderNames: 'Toso Malerot,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Royalties account',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Current Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Current Account',
                kindUri: 'current-account',
              },
            },
            state: {
              externalStateId: 'externalStateId2',
              state: 'InActive',
            },
          },
          {
            id: '3cdb2224-8926-4b4d-a99f-1c9dfbbb4600',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Company saving account',
            bankAlias: 'Langosh, Okuneva and Spencer',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 10550000,
            availableBalance: 1500,
            IBAN: 'IT09R0442267398V9QB48EV3THQ',
            BBAN: '904422673989483',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 36.16,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Savings Account',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Mile Panika',
            accountHolderNames: 'Mile Panika,Toso Malerot',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Langosh, Okuneva and Spencer',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Saving Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Saving Account',
                kindUri: 'Saving-account',
              },
            },
            state: {
              externalStateId: 'externalStateId2',
              state: 'Open',
            },
          },
          {
            id: '4cdb2224-8926-4b4d-a99f-1c9dfbbb4697',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: '3 Month Deposit',
            bankAlias: 'My Term Deposit',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 10550000,
            IBAN: 'NL81TRIO0212471066',
            BBAN: '096842613153393963',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 36.16,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Term Deposit',
            productTypeName: 'My Term Deposit',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Toso Malerot',
            accountHolderNames: 'Toso Malerot,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'My Term Deposit',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Saving Account',
              productKind: {
                id: 1,
                externalKindId: 'kind1',
                kindName: 'Saving Account',
                kindUri: 'Saving-account',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
          },
          {
            id: '5cdb2224-8926-4b4d-a99f-1c9dfbbb4696',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'House Loan',
            bankAlias: 'Our home loan',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 150000,
            principalAmount: 200000,
            IBAN: 'LU29806Y5C5H8IC1INZL',
            BBAN: '98065581',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Loan',
            productTypeName: 'House Loan',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Terence McCullough',
            accountHolderNames: 'Terence McCullough,Toso Malerot',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Our home loan',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'House Loan',
              productKind: {
                id: 5,
                externalKindId: 'kind5',
                kindName: 'Loan',
                kindUri: 'loan',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
          },
          {
            id: '2d94d333-471d-4cd7-84d2-24e822d5ca68',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Jason Smith Credit Card',
            bankAlias: 'JS Credit Card',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1250,
            availableBalance: 750,
            creditLimit: 5000,
            IBAN: 'PL47959864897829628098071024',
            BBAN: '7959864897829628098071024',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: '1234',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Credit Card',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Jason Smith',
            accountHolderNames: 'Jason Smith,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'JS Credit Card',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Investment Account',
              productKind: {
                id: 7,
                externalKindId: 'kind7',
                kindName: 'Investment Account',
                kindUri: 'investment-account',
              },
            },
            state: {
              externalStateId: 'externalStateId1',
              state: 'Active',
            },
            additions: {
              "foreignCurrency": "US",
              "foreignTotalBalance": "0.00",
              "localCurrency": "RD",
              "localCurrencyCode": "DOP",
              "foreignAvailableBalance": "2066.78",
              "localPercentageUsed": "0",
              "localAvailableBalance": "120000.00",
              "foreignPercentageUsed": "0",
              "foreignCurrencyCode": "USD",
              "creditCardAccountNumber": "4850730028704000",
              "cardTypeCode": "M",
              "localTotalBalance": "0.00"
            },
          },
          {
            id: '7cdb2224-8926-4b4d-a99f-1c9dfbbb4699',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Mr J. Smith',
            bankAlias: 'My debit card',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'RO46MHPMQM2ZAIS8MDOYXJXR',
            BBAN: '628',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Debit Card',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Alaine Kautzer III',
            accountHolderNames: 'Alaine Kautzer III,Toso Malerot',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'My debit card',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Investment Account',
              productKind: {
                id: 7,
                externalKindId: 'kind7',
                kindName: 'Investment Account',
                kindUri: 'investment-account',
              },
            },
          },
          {
            id: '8cdb2224-8926-4b4d-a99f-1c9dfbbb4695',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Mr J. Smith Execution only portfolio',
            bankAlias: 'Mr J. Investment Account',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'SI08965141761504424',
            BBAN: '8965141761504424',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 75789,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Investment Account',
            productTypeName: 'productTypeName',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'James Bond',
            accountHolderNames: 'James Bond,Toso Malerot,Jason Smith',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Mr J. Investment Account',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Investment Account',
              productKind: {
                id: 7,
                externalKindId: 'kind7',
                kindName: 'Investment Account',
                kindUri: 'investment-account',
              },
            },
          },
          {
            id: '6c1261e8-7b6b-4c14-9bb4-e976d834c730',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: '3 Month Deposit Investment',
            bankAlias: '3 Month Investment',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'SM04K79780125717VXPJ4QPEVV4',
            BBAN: '47978012571744',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 88500,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'Loan',
            productTypeName: 'Car Loan',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Otto Zulauf',
            accountHolderNames: 'Otto Zulauf,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: '3 Month Investment',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Car Loan',
              productKind: {
                id: 5,
                externalKindId: 'kind5',
                kindName: 'loan',
                kindUri: 'loan',
              },
            },
          },
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4622',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'Custom Product Kind Type 1',
            productKindName: 'My Custom Product Kind',
            productTypeName: 'My Custom Product Kind Type1',
            bankAlias: 'Custom Product Kind Type 1',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'EE044174502653307781',
            BBAN: '44174502653307781',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Colby Harvey',
            accountHolderNames: 'Colby Harvey,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'Custom Product Kind Type 1',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'Savings Account',
              productKind: {
                id: 2,
                externalKindId: 'kind2',
                kindName: 'Savings Account',
                kindUri: 'savings-account',
              },
            },
          },
          {
            id: '1cdb2224-8926-4b4d-a99f-1c9dfbbb4611',
            externalArrangementId: 'bcf10f4d-4b2f-4413-9bab-31ff693608b5',
            externalLegalEntityId: 'c7a382786d514262b75ab9531b749a2b',
            externalProductId: 'fade7867-533e-465e-90cb-e41675c54400',
            name: 'House loan account',
            bankAlias: 'My Custom Product Kind Type 2',
            sourceId: 'LJBASI2XXXX',
            bookedBalance: 1000,
            availableBalance: 1500,
            creditLimit: 442.12,
            IBAN: 'DE78342773203296369720',
            BBAN: '8342773203296369720',
            currency: 'EUR',
            externalTransferAllowed: true,
            urgentTransferAllowed: true,
            accruedInterest: 0.54,
            number: 'PANS',
            principalAmount: 620.54,
            currentInvestmentValue: 0.16,
            legalEntityIds: ['257da57a-11e4-4553-9175-54baf755069b', 'cd83683b-13f2-43d8-882b-39c9ab27d499'],
            productId: '36c8fc42-ec97-4f83-8a7c-d622625007f3',
            productNumber: 'ffdd939c-ac4a-4441-ae47-70a7259899e7',
            productKindName: 'My Custom Product Kind',
            productTypeName: 'My Custom Product Kind Type2',
            BIC: 'AABAFI22',
            bankBranchCode: 'bankBranchCode',
            visible: false,
            accountOpeningDate: '2016-01-28T16:41:41.090Z',
            accountInterestRate: 100.2,
            valueDateBalance: 100.1,
            creditLimitUsage: 100.3,
            creditLimitInterestRate: 100.4,
            creditLimitExpiryDate: '2019-09-28T16:41:41.090Z',
            startDate: '2016-02-28T16:41:41.090Z',
            termUnit: 'Y',
            termNumber: 50,
            interestPaymentFrequencyUnit: 'M',
            interestPaymentFrequencyNumber: 15,
            maturityDate: '2017-02-28T16:41:41.090Z',
            maturityAmount: 99.5,
            autoRenewalIndicator: true,
            interestSettlementAccount: 'interestSettlementAccount1',
            outstandingPrincipalAmount: 100.2,
            monthlyInstalmentAmount: 100.1,
            amountInArrear: 100.3,
            minimumRequiredBalance: 80.4,
            creditCardAccountNumber: '123456',
            validThru: '2019-02-28T16:41:41.090Z',
            applicableInterestRate: 101.2,
            remainingCredit: 50,
            outstandingPayment: 105.5,
            minimumPayment: 51.1,
            minimumPaymentDueDate: '2018-02-28T16:41:41.090Z',
            totalInvestmentValue: 110.2,
            debitCards: [
              {
                number: '4578',
                expiryDate: '2020-08-22',
                cardId: 'id1',
                cardholderName: 'John Doe',
                cardType: 'Visa Electron',
                cardStatus: 'Active',
              },
              {
                number: '3241',
                expiryDate: '2019-01-14',
                cardId: 'id2',
                cardholderName: 'John Doe',
                cardType: 'Visa',
                cardStatus: 'Active',
              },
            ],
            accountHolderAddressLine1: 'accountHolderAddressLine11',
            accountHolderAddressLine2: 'accountHolderAddressLine12',
            accountHolderStreetName: 'accountHolderStreetName1',
            town: 'Skopje',
            postCode: '2000',
            countrySubDivision: 'countrySubDivision1',
            accountHolderName: 'Tony Stark',
            accountHolderNames: 'Tony Stark,Danthe Mohr',
            accountHolderCountry: 'MK',
            creditAccount: true,
            debitAccount: true,
            lastUpdateDate: '2016-01-28T16:41:41.090Z',
            favorite: true,
            userPreferences: {
              arrangementId: '9aabca5b-63ae-47d9-8d63-c5ed0e831dfa',
              alias: 'My Custom Product Kind Type 2',
              visible: true,
              favorite: false,
            },
            product: {
              externalId: 'externalProductidId',
              externalTypeId: 'externalProductTypeId',
              typeName: 'House Loan',
              productKind: {
                id: 5,
                externalKindId: 'kind5',
                kindName: 'Loan',
                kindUri: 'loan',
              },
            },
            parentId: '1cdb2224-8926-4b4d-a99f-1c11223344',
            externalParentId: 'bcf10f4d-4b2f-4413-9bab-31ff623243125',
          },
        ],
        type: 'ProductsummaryFlatStructureGET',
      },
    ],
  },
];
export const ProductSummaryDataHttpMocksProvider = createMocks(examples, PRODUCT_SUMMARY_DATA_HTTP_ANG_CONFIG);
